import React from 'react';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';

type DataListViewProps = {
  data: {
    title: string;
    value: React.ReactNode | string | number;
  }[];
  itemWidth?: number | string;
};

export const DataListView: React.FC<DataListViewProps> = ({
  data,
  itemWidth = 'auto',
}) => (
  <List
    disablePadding
    sx={{
      flexDirection: 'row',
      flexWrap: 'wrap',
      display: 'flex',
      gap: 2,
    }}
  >
    {data.map((item, index) => (
      <ListItem
        disableGutters
        dense
        sx={{
          maxWidth: itemWidth,
          padding: 0,
          flex: 1,
        }}
        key={index}
      >
        <ListItemText
          primary={item.title}
          secondary={item.value}
          key={index}
          slotProps={{
            primary: {
              typography: 'span',
              variant: 'subtitle1',
              fontSize: '0.75rem',
              color: 'text.secondary',
            },
            secondary: { typography: 'span', variant: 'body1' },
          }}
        />
      </ListItem>
    ))}
  </List>
);
